<template>
  <v-container>
    <toolbar mode="report" title="Create" view="list" />
    <report-form 
      :working="working"
      @submit="onSubmit"
      @cancel="$router.push({ name: 'reportList' })"
    />
  </v-container>
</template>

<script>
import toolbar from "@/components/toolbar"
import ReportForm from "@/components/Reports/ReportForm"
import Reports from "@/api/reports"

export default {
  name: "ReportCreate",
  components: {
    toolbar,
    ReportForm
  },
  data() {
    return {
      working: false
    }
  },
  methods: {
    onSubmit(reportData) {
      this.working = true

      const payload = {
        ...reportData,
        owner: this.$store.state.user.id
      }

      Reports.create(payload)
        .then(response => {
          this.notify('Generating Report...')
          this.$router.push({ name: 'reportList' })
        })
        .catch(error => {
          const errorMsg = error.response && error.response.data && error.response.data.detail
            ? error.response.data.detail
            : 'Failed to create report'
          this.notify(errorMsg, 'red')
        })
        .finally(() => {
          this.working = false
        })
    }
  }
}
</script>
